// @vendors
import React from "react";

export default function PictureIcon() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45">
    <path fillRule="evenodd" d="M41.6 39.226c0 1.545-1.233 2.8-2.752 2.8h-7.11L21.6 31.576l11.745-11.95 8.255 8.4v11.2zm-36.445 2c-1.52 0-2.755-1.212-2.755-2.705v-1.27l10.946-9.625 13.854 13.6H5.155zm6.045-35.2a5.6 5.6 0 1 1 0 11.2 5.6 5.6 0 0 1 0-11.2zm27.3-5.6h-33a5.5 5.5 0 0 0-5.5 5.5v33a5.5 5.5 0 0 0 5.5 5.5h33a5.5 5.5 0 0 0 5.5-5.5v-33a5.5 5.5 0 0 0-5.5-5.5zm-27.7 13.6a2.801 2.801 0 0 0 0-5.6 2.801 2.801 0 0 0 0 5.6z"/>
</svg>
  );
}